// extracted by mini-css-extract-plugin
module.exports = {"card":"Team_card__27VaB","footer":"Team_footer__A1wN9"};